<div class="flex flex-column gap-1" data-test="ui-ql-preset-select">
    <label for="uiQlPreset" class="font-medium">Beispiel laden</label>
    @switch (state) {
        @case ('error') {
            <p-message severity="error" size="small" styleClass="w-full"
                       text="Die Beispiele konnten nicht vorbereitet werden."></p-message>
        }
        @default {
            <!-- the environment facts are fetched when the list opens (N13); the spinner shows while they load -->
            <p-select inputId="uiQlPreset" [options]="options" optionLabel="label" optionValue="value"
                      optionDisabled="disabled" [ngModel]="selectedId" (ngModelChange)="onSelect($event)"
                      [loading]="state === 'loading'" (onShow)="ensureEnvironment()"
                      placeholder="Beispiel wählen" appendTo="body" styleClass="w-full">
                <ng-template #item let-option>
                    <div class="flex flex-column gap-1">
                        <span>{{ option.label }}</span>
                        @if (option.reason) {
                            <span class="text-xs text-color-secondary">
                                <i class="fa-regular fa-ban mr-1"></i>Auf dieser Umgebung nicht verfügbar: {{ option.reason }}
                            </span>
                        }
                    </div>
                </ng-template>
            </p-select>
            <span class="text-sm text-color-secondary">Ein Beispiel ersetzt die aktuelle Abfrage im Builder.</span>
        }
    }
</div>
